export default "__VITE_ASSET__C0A44Rea__"